import * as React from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ProTip from "../ProTip"; // Adjust the path as needed
import { Link as MUILink } from "@mui/material";
import Socials from "../components/Socials";
import Banner from "../components/Banner";

function IconLink() {
  return (
    <Container maxWidth="sm">
      <Box sx={{ display: "flex", alignItems: "center", my: 4 }}>
        <HomeIcon sx={{ fontSize: 40, mr: 2 }} />{" "}
        {/* Adjust fontSize and margin as needed */}
        <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
          <Typography variant="h6">Home</Typography>
        </Link>
      </Box>
    </Container>
  );
}

export default function Home() {
  return (
    <>
      <Banner></Banner>

      <Container maxWidth="md" disableGutters>
        <Box
          sx={{
            p: 4,
            backgroundColor: "background.primary",
          }}
        >
          <Typography
            variant="h4"
            component="h1"
            sx={{
              mb: 2,
              textAlign: "center",
              fontWeight: "bold",
              fontFamily: "MedievalSharp",
            }}
          >
            Welcome to Peasant Games
          </Typography>
          <Typography sx={{ mb: 2, textAlign: "center" }}>
            I'm an independent solo game developer and who is currently working
            on a Roguelike-Strategy Game called <strong>Siegebound</strong>. The
            game combines Roguelike-Elements with Mechanics of Strategy and
            Tower-Defense Genres, creating a challenging experience where
            players build and defend a castle against relentless sieges.
            <br></br>
            <br></br>
            <strong>Siegebound</strong> is currently approaching an early alpha
            state, with big Updates coming soon!
            <br></br>
            <br></br>
            <strong>Follow for more!</strong>
          </Typography>

          {/* Video Section */}
          <Box
            sx={{
              position: "relative",
              width: "100%",
              maxWidth: "820px", // Restrict the max width of the video container
              mx: "auto", // Center the container horizontally
              paddingTop: "56.25%", // 16:9 aspect ratio (9/16 = 0.5625 or 56.25%)
              borderRadius: 3, // Rounded edges
              boxShadow: "0px 2px 12px rgba(0, 0, 0, .4)", // Custom shadow
              overflow: "hidden", // Ensures the video fits within the rounded corners
            }}
          >
            <iframe
              src="https://www.youtube.com/embed/nS4G3-QGwGA"
              title="Siegebound Trailer"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                position: "absolute", // Required to fit within the aspect-ratio container
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
            ></iframe>
          </Box>

          {/* Social Media Links Section */}
          <Socials />
        </Box>
      </Container>
    </>
  );
}
